import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=4e96ecb8&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"
import style0 from "./newPage.vue?vue&type=style&index=0&id=4e96ecb8&prod&lang=scss&scoped=true"
import style1 from "./newPage.vue?vue&type=style&index=1&id=4e96ecb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96ecb8",
  null
  
)

export default component.exports